import { render, staticRenderFns } from "./vendeursChef.vue?vue&type=template&id=3ffb5f40&"
import script from "./vendeursChef.vue?vue&type=script&lang=js&"
export * from "./vendeursChef.vue?vue&type=script&lang=js&"
import style0 from "./vendeursChef.vue?vue&type=style&index=0&id=3ffb5f40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports